import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from '@services/modal.service';
import { HelperService } from '@services/helper.service';
import { AuthService } from '@services/auth.service';

@Component({
  selector: 'app-modal-logout-error',
  templateUrl: './modal-logout-error.component.html',
  styleUrls: ['./modal-logout-error.component.scss'],
})
export class ModalLogoutErrorComponent {
  
  constructor(
    private auth: AuthService,
    public modal: ModalService,
    public helper: HelperService) {}


  close() {
    this.modal.close();
  }

  logOut() {
    (window as any).gtag('event', 'cerrar-sesion-conrmada', {
      event_category: 'cerrar-sesión',
      event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.userInfo.email}`,
    });
    this.helper.logOut();
  }
}